module.exports = __webpack_public_path__ + "img/firework-right.ea74531d.svg";